<template>
  <div class="userList-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-select
        placeholder="VIP等级"
        size="small"
        clearable
        v-model="userParam.vipLevel"
        @change="refreshSearch"
      >
        <el-option
          v-for="item in vipLevelList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        placeholder="是否有推广码"
        size="small"
        clearable
        v-model="userParam.hasPromotionCode"
        @change="refreshSearch"
      >
        <el-option
          v-for="item in hadPromotList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        placeholder="是否禁止上传"
        v-model="userParam.forbidUpload"
        clearable
        size="small"
        @change="refreshSearch"
      >
        <el-option
          v-for="item in isForbid"
          :key="item.value"
          :value="item.value"
          :label="item.label"
        ></el-option>
      </el-select>
      <el-select
        placeholder="是否封禁"
        v-model="userParam.hasLocked"
        clearable
        size="small"
        @change="refreshSearch"
      >
        <el-option
          v-for="item in isLockList"
          :key="item.value"
          :value="item.value"
          :label="item.label"
        ></el-option>
      </el-select>
      <el-select
        placeholder="是否禁言"
        v-model="userParam.hasBanned"
        clearable
        size="small"
        @change="refreshSearch"
      >
        <el-option
          v-for="item in isBannedList"
          :key="item.value"
          :value="item.value"
          :label="item.label"
        ></el-option>
      </el-select>
      <el-select
        placeholder="是否马甲账号"
        v-model="userParam.isPretendAcc"
        clearable
        size="small"
        @change="refreshSearch"
      >
        <el-option
          v-for="item in isVestAccount"
          :key="item.value"
          :value="item.value"
          :label="item.label"
        ></el-option>
      </el-select>
      <el-input
        placeholder="请输入用户id"
        clearable
        v-model="userParam.uid"
        size="small"
        @keyup.enter.native="refreshSearch"
        class="param-input"
      ></el-input>
      <el-input
        placeholder="请输入用户名"
        clearable
        v-model="userParam.name"
        size="small"
        @keyup.enter.native="refreshSearch"
        class="param-input"
      ></el-input>
      <el-input
        placeholder="请输入手机号码"
        clearable
        v-model="userParam.mobile"
        size="small"
        @keyup.enter.native="refreshSearch"
        class="param-input"
      ></el-input>
      <el-input
        placeholder="请输入推广码"
        clearable
        v-model="userParam.promotionCode"
        size="small"
        @keyup.enter.native="refreshSearch"
        class="param-input"
      ></el-input>
      <el-input
        placeholder="请输入渠道"
        clearable
        v-model="userParam.districtCode"
        size="small"
        @keyup.enter.native="refreshSearch"
        class="param-input"
      ></el-input>
      <el-date-picker
        v-model="time"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        @change="changeTime"
      ></el-date-picker>
      <el-button type="primary" size="small" @click="refreshSearch"
        >搜索</el-button
      >
      <el-button type="primary" size="small" @click="exportdata"
        >导出</el-button
      >
      <el-button type="primary" size="small" @click="code()"
        >点击查看验证码</el-button
      >
      <el-button type="primary" size="small" @click="openReason('user')"
        >封禁原因配置</el-button
      >
      <el-button type="primary" size="small" @click="openReason('upload')"
        >禁止上传原因配置</el-button
      >
    </div>
    <!--表格数据-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="520"
    >
      <el-table-column
        prop="uid"
        label="用户ID"
        align="center"
        width="120"
        fixed
      >
        <template slot-scope="scope">
          <span>{{ scope.row.uid || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="districtCode"
        label="渠道"
        align="center"
        fixed
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.districtCode || "无" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="merchantAccount"
        label="商家账号"
        align="center"
        fixed
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.merchantAccount || "无" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="devID"
        class-name="col_layout"
        label="UUID"
        align="center"
        width="400px"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.devID || "未知" }}</span>
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-refresh"
            @click="refreshDev(scope.row.uid)"
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="registerIP"
        label="注册IP"
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.registerIP || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="手机号码"
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.mobile || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="昵称" align="center" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.name || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="bankActName"
        label="绑定银行卡名称"
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.bankActName || "-" }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="userImage"
        label="用户头像"
        align="center"
        width="140"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <img-load
            :width="'80px'"
            :height="'80px'"
            :src="imgUrl + scope.row.portrait"
          ></img-load>
        </template>
      </el-table-column>

      <el-table-column
        prop="summary"
        label="个人简介"
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.summary || "未知" }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="vipLevelLabel"
        label="VIP等级"
        align="center"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="vipExpireDate"
        label="VIP到期时间"
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.vipExpireDate | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="chatPrice"
        label="私信价格"
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.chatPrice || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="payVidDiscount"
        label="金币视频折扣"
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.payVidDiscount || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="goldVideoFreeExpire"
        label="金币视频免费时间"
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.goldVideoFreeExpire | changeDate }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="channel" label="渠道" align="center" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.channel || "未知" }}</span>
        </template>
      </el-table-column>-->
      <!--TODO -->
      <el-table-column
        prop="devType"
        label="设备类型"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.devType || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="注册时间"
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="loginDays"
        label="登陆天数"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.loginDays || "0" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="lastActive"
        label="最后活跃时间"
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.lastActive | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="amount"
        label="金币余额"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.amount || "0" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="income"
        label="金币收益"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.income || "0" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="rewarded"
        label="打赏金额"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.rewarded || "0" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="aiUndressFreeTimes"
        label="AI脱衣剩余次数"
        align="center"
        width="80"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.aiUndressCount || "0" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="downloadCount"
        label="下载次数"
        align="center"
        width="80"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.downloadCount || "0" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="inviterID"
        label="上级ID"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.inviterID || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="promotionCode"
        label="推广码"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.promotionCode || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="inviteCount"
        label="邀请数"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.inviteCount || "0" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="originalSort"
        label="原创博主排序"
        align="center"
        width="110"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.originalSort || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="lockReason"
        label="封禁原因"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.lockReason || "未封禁" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="lockImg"
        label="封禁图片"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          <img-load
            v-if="scope.row.lockImg"
            :width="'80px'"
            :height="'80px'"
            :src="imgUrl + scope.row.lockImg"
          ></img-load>
          <span v-if="!scope.row.lockImg">暂无图片</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="isDirect"
        label="是否直推用户"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.isDirect ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="superUser"
        label="是否是大V"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.superUser ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="officialCert"
        label="是否官方认证"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.officialCert ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="isMadou"
        label="是否工作室"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.isMadou ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="isAdvertiser"
        label="是否打广告用户"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.isAdvertiser ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="taxLevel"
        label="视频扣税率"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.taxLevel | taxLevelList }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="region" label="城市" align="center" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.region || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="videoCnt"
        label="视频数"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.videoCnt }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="undealVideoCnt"
        label="未审核视频数"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.undealVideoCnt }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="400">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.forbidUpload"
            type="info"
            size="mini"
            @click="udpateForbid(scope.row, false)"
            >解除禁止上传</el-button
          >
          <el-button
            v-else
            type="warning"
            size="mini"
            @click="openSelectReason(scope.row, 'upload')"
            >禁止上传</el-button
          >
          <el-button type="success" size="mini" @click="editUser(scope.row)"
            >编辑</el-button
          >
          <el-button
            v-if="scope.row.hasBanned"
            type="info"
            size="mini"
            @click="unbanned(scope.row)"
            >解除禁言</el-button
          >
          <el-button
            v-else
            type="warning"
            size="mini"
            @click="banned(scope.row)"
            >禁言</el-button
          >
          <el-button type="danger" size="mini" @click="addVip(scope.row)"
            >添加会员卡</el-button
          >
          <el-button
            type="info"
            size="mini"
            @click="recycleGold(scope.row)"
            v-if="auth"
            >回收金币</el-button
          >
          <br /><br />
          <el-button
            v-if="!scope.row.hasLocked"
            type="danger"
            size="mini"
            @click="openSelectReason(scope.row, 'user')"
            >封禁</el-button
          >
          <el-button
            v-else
            type="primary"
            size="mini"
            @click="unprohibit(scope.row)"
            >解封</el-button
          >

          <el-button
            type="info"
            size="mini"
            @click="recycleBalance(scope.row)"
            v-if="auth"
            >回收游戏余额</el-button
          >
          <el-button type="success" size="mini" @click="vipInfo(scope.row)">
            VIP权益
          </el-button>

          <el-button type="warning" size="mini" @click="watchQrcode(scope.row)">
            账号凭证
          </el-button>
          <br /><br />
          <el-button
            v-if="scope.row.isAdvertiser"
            type="info"
            size="mini"
            @click="unAdvertiser(scope.row)"
            >取消打广告用户</el-button
          >
          <el-button
            v-else
            type="warning"
            size="mini"
            @click="advertiser(scope.row)"
            >设置打广告用户</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[5, 10, 20, 30]"
      :current-page="userParam.pageNumber"
      :page-size="userParam.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 1"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!--用户编辑弹窗-->
    <edit-user ref="editUser" @goBack="search"></edit-user>
    <!-- 点击查看二维码 -->
    <verification-code ref="verificationCode"></verification-code>
    <!--封禁理由弹窗-->
    <reason-action ref="reasonAction" />
    <select-reason ref="selectReason" @handleList="getUserList(userParam)" />
    <!-- 解封操作 -->
    <unblock-page ref="unblockPage" @handleList="getUserList(userParam)" />
    <!-- 回收游戏余额弹窗 -->
    <recycleGameBalance
      ref="recycleBalance"
      @goBack="search"
      @handleList="getUserList(userParam)"
    />
    <!-- VIP信息弹窗 -->
    <vipInfo
      ref="vipInfo"
      @goBack="search"
      @handleList="getUserList(userParam)"
    />
    <!-- 回收金币弹窗 -->
    <recycleGold
      ref="recycleGold"
      @goBack="search"
      @handleList="getUserList(userParam)"
    />
    <!-- 账号凭证 -->
    <qrcode ref="qrcode" />

    <el-dialog
      title="添加会员卡"
      :visible.sync="isBindVip"
      width="400px"
      @close="bindVipClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" label-width="140px">
        <div class="form_item">
          <div class="form_item_name">会员卡</div>
          <el-select v-model="bindVipCard" clearable="" size="small">
            <el-option
              v-for="item in vipList"
              :key="item.id"
              :label="item.newName"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isBindVip = false" size="medium">取 消</el-button>
        <el-button type="primary" @click="confirmBind" size="medium"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import baseConfig from "@/utils/serverUrlConfig";
//import { paramsFilter } from "@/utils/global";
import EditUser from "./components/edit-user";
import ReasonAction from "@/components/reasonAction";
import SelectReason from "@/components/selectReasonAction";
import UnblockPage from "./components/unblockPage";
import RecycleGameBalance from "./components/recycleGameBalance";
import RecycleGold from "./components/recycleGold";
import Qrcode from "./components/qrcode";
import VipInfo from "./components/vipInfo.vue";
import { changeTime } from "@/utils/global";
import API from "@/api";
import VerificationCode from "./components/verification-code";
import { sortEscape } from "@/utils/global";
import { validatorMobile } from "@/utils/validator";
export default {
  data() {
    return {
      dialogFormVisible: false,
      banTableData: [],
      uid: "",
      auth: true,
      banTotal: "",
      banLoading: false,
      form: {
        phone: "",
      },
      imgUrl: baseConfig.imgUrl,
      roleList: [
        { value: "snap", label: "普通用户" },
        { value: "user", label: "VIP用户" },
      ],
      vipLevelList: [
        { value: 0, label: "非VIP" },
        { value: 1, label: "VIP" },
        { value: 2, label: "超级VIP" },
        { value: 3, label: "SSVIP" },
      ],
      hadPromotList: [
        { value: true, label: "有" },
        { value: false, label: "无" },
      ],
      rules: {
        phone: [
          {
            required: true,
            message: "请输入正确格式的手机号码",
            trigger: "blur",
          },
          { validator: validatorMobile, trigger: "blur" },
        ],
      },
      // 表格数据加载动画
      loading: false,
      tableData: [],
      time: "",
      total: 0,
      idList: [],
      vipList: [],
      // 封禁理由列表参数
      params: {
        pageNumber: 1,
        pageSize: 10,
      },
      bindVipCard: "",
      isBindVip: false,
      bindUid: "",
      // 用户管理列表请求参数
      userParam: {
        uid: "",
        pageNumber: 1,
        pageSize: 10,
        key: "",
        hasBanned: "",
        isPretendAcc: "",
        value: "",
        role: null,
        vipLevel: null,
        hasPromotionCode: null,
        name: null,
        mobile: null,
        promotionCode: null,
        districtCode: null,
        forbidUpload: null,
        startTime: "",
        endTime: "",
        captcha: "",
      },
      isForbid: [
        { label: "已禁止", value: true },
        { label: "未禁止", value: false },
      ],
      isLockList: [
        { label: "已封禁", value: true },
        { label: "未封禁", value: false },
      ],
      isBannedList: [
        { label: "已禁言", value: true },
        { label: "未禁言", value: false },
      ],
      isVestAccount: [
        { label: "马甲账号", value: 1 },
        { label: "所有账号", value: 2 },
      ],
    };
  },
  components: {
    EditUser,
    VerificationCode,
    SelectReason,
    ReasonAction,
    UnblockPage,
    RecycleGameBalance,
    RecycleGold,
    VipInfo,
    Qrcode,
  },
  created() {
    this.auth = true;
    this.queryVipCard();
    // this.auth = validatorAuthority();
    // this.getUserList(this.userParam);
  },
  methods: {
    async queryVipCard() {
      let res = await API.queryVipCard({ status: true });
      if (res && res.code == 200) {
        this.vipList = res.data;
      }
    },
    udpateForbid(row, type) {
      const params = Object.assign(
        {},
        {
          uidList: [row.uid],
          enable: type,
        }
      );
      API.resetForbid(params)
        .then((res) => {
          res.code === 200 &&
            (this.$message.success("修改用户禁止上传文件状态成功！"),
            this.getUserList(this.userParam));
        })
        .catch(() => {
          this.$message.error("操作失败，请重试");
        });
    },
    // 查看二维码
    code() {
      this.$refs.verificationCode.open();
    },
    // 封禁原因配置
    openReason(type) {
      this.$refs.reasonAction.open(type);
    },
    // 根据手机号查看或生成验证码
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.getViewCaptcha();
        } else {
          window.console.log("error submit!!");
          return false;
        }
      });
    },
    getViewCaptcha() {
      this.loading = true;
      API.getViewCaptcha(this.phone)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.dialogFormVisible = false;
            let captcha = res.data.captcha;
            return captcha;
          }
        })
        .then((captcha) => {
          this.$message({
            type: "success",
            message: "你的验证码是: " + captcha,
          });
        });
      this.getUserList(this.userParam);
    },
    // 更新设备
    refreshDev(uid) {
      this.$confirm("您确定要更新当前用户的设备id？", "更新提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "cancel_right",
        type: "warning",
      })
        .then(() => {
          let params = {
            uid: uid,
          };
          API.resetDev(params).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "用户设备id更新成功",
                type: "success",
              });
              this.refreshSearch();
            }
          });
        })
        .catch(() => {});
    },
    // 时间选择回掉
    changeTime(time) {
      if (time) {
        this.userParam.startTime = changeTime(time[0]);
        this.userParam.endTime = changeTime(time[1]);
      } else {
        this.userParam.startTime = "";
        this.userParam.endTime = "";
      }
      this.refreshSearch();
    },
    // 搜索对应列表
    refreshSearch() {
      this.userParam.pageNumber = 1;
      this.getUserList(this.userParam);
    },
    // 导出数据
    exportdata() {
      // let params = paramsFilter(this.userParam);
      // let str = "";
      // for (let key in params) {
      //   if (key == "startTime" || key == "endTime") {
      //     params[key] = params[key].replace("+", "%2B");
      //   }
      //   str += key + "=" + params[key] + "&";
      // }
      // str = str.substring(0, str.length - 1);
      // let url = baseConfig.baseServerUrl + "/export/userList?" + str;
      // window.location.href = url;
      let req = JSON.parse(JSON.stringify(this.userParam));
      this.exportLoading = true;
      API.exportUserList(req)
        .then((res) => {
          if (res && res.code == 200) {
            this.$message.success(
              "操作成功，请耐心等待数据导出到TG<数据导出对接群>"
            );
          }
        })
        .catch(() => {
          this.$message.error("导出失败！");
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
    // 搜索对应列表
    search() {
      this.getUserList(this.userParam);
    },
    // 请求用户列表
    getUserList(obj) {
      this.loading = true;
      API.getUserList(obj)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            let roleObj = {
                snap: "普通用户",
                user: "VIP用户",
              },
              vipObj = {
                0: "非VIP用户",
                1: "铂金卡",
                2: "钻石卡",
                3: "至尊卡",
              };
            this.tableData = res.data.list;
            this.tableData.forEach((item) => {
              item.roleLabel = roleObj[item.role] ? roleObj[item.role] : "-";
              item.vipLevelLabel = vipObj[item.vipLevel]
                ? vipObj[item.vipLevel]
                : "-";
            });
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 数据排序
    handleSortChange(column) {
      this.userParam.value = sortEscape(column.order);
      this.userParam.key = column.prop;
      this.getUserList(this.userParam);
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.userParam.pageSize = size;
      this.userParam.pageNumber = 1;
      this.getUserList(this.userParam);
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.userParam.pageNumber = pageNumber;
      this.getUserList(this.userParam);
    },
    // 编辑用户
    editUser(row) {
      this.$refs.editUser.open(row);
    },
    // 请求禁言或解禁用户
    banUser(params) {
      API.getUserBan(params).then((res) => {
        if (res.code === 200) {
          if (params.enable) {
            this.$message({
              message: "禁言用户成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "解除禁言成功",
              type: "success",
            });
          }
          this.search();
        }
      });
    },
    // 禁言用户
    banned(row) {
      this.$confirm("您确定要禁言当前用户？", "禁言提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            uidList: [row.uid],
            enable: true,
          };
          this.banUser(params);
        })
        .catch(() => {});
    },
    // 解除禁言用户
    unbanned(row) {
      this.$confirm("您确定要解除当前用户禁言？", "解除禁言提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            uidList: [row.uid],
            enable: false,
          };
          this.banUser(params);
        })
        .catch(() => {});
    },
    advertiserUser(params) {
      API.setUserAdv(params).then((res) => {
        if (res.code === 200) {
          if (params.enable) {
            this.$message({
              message: "设置打广告用户成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "取消打广告用户成功",
              type: "success",
            });
          }
          this.search();
        }
      });
    },
    // 设置打广告用户
    advertiser(row) {
      this.$confirm("您确定要设置当前用户打广告？", "设置提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            uid: [row.uid],
            enable: true,
          };
          this.advertiserUser(params);
        })
        .catch(() => {});
    },
    // 取消打广告用户
    unAdvertiser(row) {
      this.$confirm("您确定要取消当前用户打广告？", "取消提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            uid: [row.uid],
            enable: false,
          };
          this.advertiserUser(params);
        })
        .catch(() => {});
    },
    // 点击封禁按钮打开弹窗
    openSelectReason(row, type) {
      this.$refs.selectReason.open(row, type);
    },
    // 点击解禁按钮打开弹窗
    unprohibit(row) {
      this.$refs.unblockPage.open(row);
    },
    // 回收游戏余额
    recycleBalance(row) {
      this.$refs.recycleBalance.open(row);
    },
    // 回收金币
    recycleGold(row) {
      this.$refs.recycleGold.open(row);
    },
    // 查看视频观看列表
    checkedVideo(row) {
      this.$refs.viewVideo.open(row);
    },
    // vip信息
    vipInfo(row) {
      this.$refs.vipInfo.open(row);
    },
    //查看账号凭证
    watchQrcode(row) {
      this.$refs.qrcode.open(row);
    },
    addVip(row) {
      this.isBindVip = true;
      this.bindUid = row.uid;
    },
    bindVipClose() {
      this.bindVipCard = "";
      this.bindUid = "";
    },
    confirmBind() {
      if (!this.bindVipCard) {
        this.$message({
          message: "请选择会员卡",
          type: "error",
        });
        return;
      }
      let params = {
        uid: this.bindUid,
        vipID: this.bindVipCard,
      };
      API.editUser(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.$emit("goBack");
          } else {
            this.$message.error("添加失败");
          }
          this.isBindVip = false;
        })
        .catch(() => {
          this.isBindVip = false;
        });
    },
  },
};
</script>
<style lang="scss">
.el-message-box {
  .cancel_right {
    float: right;
    margin-left: 10px;
  }
}
</style>
<style scoped lang="scss">
.userList-box {
  .v-number {
    vertical-align: middle;
  }
  .view-details {
    margin-left: 10px;
    color: #e63765;
    font-size: 18px;
    cursor: pointer;
    vertical-align: middle;
    &:hover {
      color: #eb5f84;
    }
  }
  /deep/.col_layout {
    /deep/ div {
      display: flex;
      justify-content: center;
      padding-left: 50px;
      button {
        margin-left: auto;
      }
    }
  }
}
.form_item {
  display: flex;
  align-items: center;
  justify-content: center;
  .form_item_name {
    margin-right: 20px;
  }
}
</style>
